export const LOCATION_SUCCESS_TOAST_OPTIONS = {
  position: 'top',
  timeout: 2500
}

export const LOCATION_INFO_TOAST_OPTIONS = {
  position: 'top',
  timeout: 3000
}

export const LOCATION_WARNING_TOAST_OPTIONS = {
  position: 'top',
  timeout: 3500
}

export const LOCATION_ERROR_TOAST_OPTIONS = {
  position: 'top',
  timeout: 4000
}

// Backward-compatible alias for existing mismatch warning usage.
export const LOCATION_MISMATCH_TOAST_OPTIONS = LOCATION_WARNING_TOAST_OPTIONS

export const resolveLocationName = (locationId, locations = [], fallbackPrefix = 'location #') => {
  const id = Number(locationId)
  if (!id) return `${fallbackPrefix}unknown`
  const matched = (locations || []).find(loc => Number(loc?.id) === id)
  return matched?.name || `${fallbackPrefix}${id}`
}

export const messageOpenRegisterInLocation = (locationName, actionText = 'Switch to that location or close it first.') => {
  return `You already have a register open in ${locationName}. ${actionText}`
}
